import { render, staticRenderFns } from "./Tarifs_edit.vue?vue&type=template&id=4269d654&"
import script from "./Tarifs_edit.vue?vue&type=script&lang=js&"
export * from "./Tarifs_edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports